import Vue from 'vue'
import Router from 'vue-router'
// 动态路由注册
import homeRouter from './modules/home'
import putinRouter from './modules/putin'
import assetsRouter from './modules/assets'
import toolRouter from './modules/tool'
import reportRouter from './modules/report'
import selfopRouter from './modules/selfop'
// import materialRouter from './modules/material'
import monitorRouter from './modules/monitor'
import accountRouter from './modules/account'
import clienteleRouter from './modules/clientele'
// import analyzeRouter from './modules/analyze'

import qcPutinRouter from './qianchuan/putin'
import qcReportRouter from './qianchuan/report'
import qcMonitorRouter from './qianchuan/monitor'
import qcassetslRouter from './qianchuan/assets'
import qcaccountRouter from './qianchuan/account'
import qcselfopRouter from './qianchuan/selfop'

// 公用-账户安全中心
import accountInfoCenter from './modules/accountInfoCenter'

Vue.use(Router)
export const asyncRoutes = [homeRouter, putinRouter, assetsRouter, toolRouter, reportRouter, selfopRouter, monitorRouter, accountRouter, clienteleRouter, accountInfoCenter]
export const qcAsyncRoutes = [qcPutinRouter, qcassetslRouter, qcReportRouter, qcselfopRouter, qcMonitorRouter, qcaccountRouter, accountInfoCenter]

export const constantRoutes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/404',
    component: () => import('@/views/404')
  },
  {
    path: '/empty',
    component: () => import('@/views/empty')
  },
  {
    path: '/login',
    name: 'login',
    component: resolve => require(['@/views/login'], resolve),
    meta: {
      keepAlive: false // 设置是否展示公共部分 false为不显示
    }
  },
  {
    path: '/register',
    name: 'register',
    component: resolve => require(['@/views/register'], resolve),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/protocol',
    name: 'protocol',
    component: resolve => require(['@/views/protocol/protocol'], resolve),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/privacyPolicy',
    name: 'privacyPolicy',
    component: resolve => require(['@/views/protocol/privacyPolicy'], resolve),
    meta: {
      keepAlive: false
    }
  }
]
// 跳转失败重复跳转报异常的解决方式
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

const createRouter = () => new Router({
  mode: 'history', // require service support
  // base: 'hr/',
  // scrollBehavior: () => ({ y: 0 }),
  routes: [...constantRoutes] // 静态路由和动态路由的临时合并
})
const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router



// WEBPACK FOOTER //
// ./src/router/router.js